module.exports = __webpack_public_path__ + "img/first_wave_top.490b2713.svg";